import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { CancelButton } from "../Controls/CancelButton";
import { ConfirmButton } from "../Controls/ConfirmButton";
import { ImagesInput } from "../Controls/ImagesInput";
import StandardImageList from "../ImageList/ImageList";
import QueueStyle from "../Styled/Queue.style";
import StackStyle from "../Styled/Stack.style";

export default function UsedCarImageGallery({
  open,
  onClose,
  images,
  setLocalImages,
  setAllImages,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"unset"}>
      <DialogTitle>Image gallery</DialogTitle>
      <DialogContent>
        <StackStyle gap="10px">
          <StandardImageList images={images} setImages={setAllImages} />
          <QueueStyle justifyContent="end">
            <ImagesInput value={images} setValue={setLocalImages} />
          </QueueStyle>
        </StackStyle>
      </DialogContent>
      <DialogActions>
        <QueueStyle>
          <CancelButton onClick={onClose} />
          <ConfirmButton
            disabled={images?.length === 0 || images?.some(img => img.tooLarge)}
            onClick={onClose}
          />
        </QueueStyle>
      </DialogActions>
    </Dialog>
  );
}
